export default __webpack_public_path__ + "static/media/Facturacion-orange.9914eaa0.svg";